import { useEffect, useState } from 'react'

import { Spinner } from 'components/Spinner'

import { Container } from './Container'

export const loaderDelay = 0.1

type Props = {
	isVisible: boolean
}

export const Loader = ({ isVisible }: Props) => {
	const [isReady, setIsReady] = useState(false)

	useEffect(() => {
		if (isVisible) {
			const timeout = setTimeout(() => {
				setIsReady(true)
				clearTimeout(timeout)
			}, loaderDelay * 1000)

			return () => {
				clearTimeout(timeout)
			}
		}
	}, [isVisible])

	return (
		<Container isVisible={isVisible && isReady} loaderDelay={loaderDelay}>
			<Spinner />
		</Container>
	)
}
